/* ZQUARO · ficha de producto: estrellas encima del precio + ventana de Judge.me con la foto de portada */
(function () {
  var css = '' +
    /* Estrellas reales (Judge.me) encima del precio */
    'body .product-information .rating-wrapper{display:flex!important;align-items:center;gap:8px}' +
    'body .product-information .rating-wrapper .rating{--star-size:18px!important}' +
    'body .product-information .rating-wrapper .rating-count{font-size:14px!important;color:#1B2A3D!important}' +
    'body .zq-pdp-rating{display:none!important}' +
    /* Ventana para escribir reseña: solo la foto de la prenda */
    '.jdgm-write-review-modal img:not(.zq-jm-img img){display:none!important}' +
    '.jdgm-write-review-modal [class*="product-image"]:not(.zq-jm-img),' +
    '.jdgm-write-review-modal [class*="product-img"]:not(.zq-jm-img),' +
    '.jdgm-write-review-modal [class*="__image"]:not(.zq-jm-img),' +
    '.jdgm-write-review-modal [class*="thumbnail"]{display:none!important}' +
    '.jdgm-write-review-modal .zq-jm-img, .jdgm-write-review-modal .zq-jm-img img{display:block!important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function productImage() {
    var sec = document.getElementById('opiniones');
    return sec ? (sec.dataset.productImage || '').replace(/width=\d+/, 'width=600') : '';
  }
  function decorate() {
    var src = productImage();
    if (!src) return;
    document.querySelectorAll('.jdgm-write-review-modal__product-title').forEach(function (t) {
      var prev = t.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('zq-jm-img')) return;
      var wrap = document.createElement('div');
      wrap.className = 'zq-jm-img';
      var img = document.createElement('img');
      img.src = src;
      img.alt = t.textContent.trim();
      wrap.appendChild(img);
      t.parentNode.insertBefore(wrap, t);
    });
    document.querySelectorAll('.jdgm-write-review-modal [style*="background-image"]').forEach(function (e) {
      if (!e.closest('.zq-jm-img')) e.style.display = 'none';
    });
  }
  /* Al pulsar las estrellas, bajar a las opiniones */
  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('.product-information .rating-wrapper');
    var sec = document.getElementById('opiniones');
    if (w && sec) { e.preventDefault(); sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  new MutationObserver(function () { decorate(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', decorate);
})();
